import { select } from '@panel/commons/core/themev2';
import styled from 'styled-components';
import OperationTypeIcon from '@panel/commons/assets/icons/OperationTypeIcon.svg';
import PropertyTypeIcon from '@panel/commons/assets/icons/PropertyTypeIcon.svg';
import LocationIcon from '@panel/commons/assets/icons/LocationIcon.svg';

const Icons = {
  operation: OperationTypeIcon,
  property: PropertyTypeIcon,
  location: LocationIcon
};

const Container = styled.div`
  max-width: 290px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: ${select('white')};
  border-radius: 15px;
  font-family: 'Hind';
  box-shadow: 0px 2px 23px rgba(124, 152, 167, 0.08);
  visibility: ${props => (props.visible ? 'visible' : 'hidden')};
  div:last-of-type {
    margin-bottom: 0 !important;
  }
`;

const Title = styled.div`
  font-family: 'Hind';
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 16px;
`;

const Item = styled.div`
  display: flex;
  align-content: center;
  margin-bottom: 8px;
  span {
    display: inline-block;
    background-image: ${props => `url(${Icons[props.icon]})`};
    background-repeat: no-repeat;
    background-size: contain;
    height: 15px;
    width: 15px;
    margin-right: 9px;
  }
  p {
    font-family: 'Hind';
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 19px;
    color: ${select('darkGray')};
  }
`;

export { Container, Title, Item };
